module.exports = __webpack_public_path__ + "static/ldj-case-study-4c8480bd75737b6dea257bb015c17e87.png";